import menu from './menu-bar';
import menu_group from './menu-group';
import menu_item from './menu-item';
import menu_item_dropdown from './menu-item-dropdown';
import dropdown_item from './dropdown-item';
import dropdown_divider from './dropdown-divider';
import modal from './modal';
import auto_modal from './modal/auto-modal';
import modal_body from './modal/modal-body';
import modal_header from './modal/modal-header';
import modal_footer from './modal/modal-footer';
import modal_new from './modal-new';
import modal_body_new from './modal-new/modal-body';
import modal_header_new from './modal-new/modal-header';
import modal_footer_new from './modal-new/modal-footer';
import button from './button';
import button_option from './button-option';
import button_floating from './button-floating';
import accordion from './accordion';
import accordion_button from './accordion-button';
import accordion_card from './accordion-card';
import product_card from './product_card';
import product_banner from './product_banner';
import product_list from './product_list';
import upload_files from './upload-files';
import multi_selector_dropdown from './multi-selector-dropdown';
import page from './page';
import block from './block';
import spinner from './spinner';
import data_form from './data-form';
import data_form_header from './data-form/data-form-header';
import data_form_body from './data-form/data-form-body';
import data_form_footer from './data-form/data-form-footer';
import form from './form';
import facility_selector from './facility-selector';
import list from './list';
import list_header from './list/list-header';
import list_table from './list/list-table';
import list_controller from './list/list-controller';
import list_grid from './list/list-grid';
import list_map from './list/list-map';
import list_calendar from './list/list-calendar';
import list_table_column from './list/list-table/list-table-column';
import list_table_header from './list/list-table/list-table-header';
import data_dropdown from './data-dropdown';
import data_provider from './data-provider';
import data_navigation from './data-navigation';
import data_navigation_grid from './data-navigation-grid';
import data_navigation_form from './data-navigation-form';
import input_field from './input-field';
import input_rich_text from './input-field/input-types/input-rich-text';
import input_email from './input-field/input-types/input-email';
import input_phone from './input-field/input-types/input-phone';
import input_address from './input-address';
import input_file from './input-file';
import input_file_selector from './input-file-selector';
import checkbox_field from './checkbox-field';
import campaign_selector_single from './campaign-selector-single';
import datetime_picker from './datetime-input-field';
import layout from './layout';
import row from './row';
import column from './column';
import column_break from './column-break';
import card from './card';
import card_header from './card/card-header';
import card_body from './card/card-body';
import tabs from './tabs';
import link_tabs from './tabs/link-tabs';
import content_tabs from './tabs/content-tabs';
import tab_link from './tabs/tab-link';
import tab_content from './tabs/tab-content';
import input_search from './input-search';
import multi_sort from './multi-sort';
import left_drawer from './left-drawer';
import right_drawer from './right-drawer';
import menu_view_navigation from './menu-view-navigation';
import document_wrapper from './document-wrapper';
import rich_text_editor from './rich-text-editor';
import infinite_scroll_list from './infinite-scroll-list';
import share_modal from './share-modal';
import html_content from './html-section';
import collapse from './collapse';
import collapse_button from './collapse-button';
import print_modal from './print-modal';
import file_viewer from './file-viewer';
import file_list from './file-list';
import file_selector from './file-selector';
import file_viewer_modal from './file-viewer-modal';
import toast from './toast';
import merchantTransactionModal from './merchant-transaction-modal';
import map from './map';
import calendar from './calendar';
import image_cropper from './image-cropper';
import chart from './chart';
import audio_player from './audio-player';
import circle from './circle';
import video_player from './video-player';
import page_header from './page/page-header';
import page_body from './page/page-body';
import data_mode_selector from './data-mode-selector';
import data_mode_crud_modal from './data-mode-crud-modal';
import image from './image';
import text from './text';
import flex from './flex';
import icon from './icon';
import popover from './popover';
import alert from './alert';
import skeleton_row from './skeletons/row';
import skeleton_list from './skeletons/list';
import loop from './loop';
import space from './space';
import search from './search';
import group from './group';
import badge from './badge';
import input_search_selector from './input-search-selector';
import confirm from './confirm';
import install_app_button from './install-app-button';
import notification_subscription_button from './notification-subscription-button';
import dropzone from './dropzone';
import qrcode from './qrcode';

import ks_custom_single_selector from './select-field/ks-custom-single-selector';
import ks_multi_selector from './select-field/ks-multi-selector';
import ks_multi_selector_tree from './select-field/ks-multi-selector-tree';
import ks_single_selector from './select-field/ks-single-selector';
import ks_single_selector_button from './select-field/ks-single-selector-button';
import ks_single_selector_radio from './select-field/ks-single-selector-radio';
import ks_campaign_multi_selector from './select-field/ks-campaign-multi-selector';
import ks_campaign_single_selector from './select-field/ks-campaign-single-selector';

import data_grid from './data-grid';
import data_grid_column from './data-grid/data-grid-column';
import data_grid_header from './data-grid/data-grid-header';
import overlay from './overlay';
import requestPerformanceLogs from './request-performance-logs';

export default {
  'menu-bar': menu,
  'menu-group': menu_group,
  'menu-item': menu_item,
  'menu-item-dropdown': menu_item_dropdown,
  'dropdown-item': dropdown_item,
  'dropdown-divider': dropdown_divider,
  'ks-modal': modal,
  'ks-auto-modal': auto_modal,
  'ks-modal-body': modal_body,
  'ks-modal-header': modal_header,
  'ks-modal-footer': modal_footer,
  'ks-modal-new': modal_new,
  'ks-modal-body-new': modal_body_new,
  'ks-modal-header-new': modal_header_new,
  'ks-modal-footer-new': modal_footer_new,
  'ks-button': button,
  'ks-button-option': button_option,
  'ks-accordion': accordion,
  'ks-accordion-button': accordion_button,
  'ks-accordion-card': accordion_card,
  layout: layout,
  'ks-product-card': product_card,
  'ks-product-banner': product_banner,
  'ks-product-list': product_list,
  'ks-upload-files': upload_files,
  'multi-selector-dropdown': multi_selector_dropdown,
  'ks-page': page,
  'ks-block': block,
  'ks-spinner': spinner,
  'ks-datetime-picker': datetime_picker,
  'ks-data-form': data_form,
  'ks-data-form-header': data_form_header,
  'ks-data-form-body': data_form_body,
  'ks-data-form-footer': data_form_footer,
  'ks-form': form,
  'ks-facility-selector': facility_selector,
  'ks-input-field': input_field,
  'ks-input-file': input_file,
  'ks-checkbox-field': checkbox_field,
  'ks-data-provider': data_provider,
  'ks-data-dropdown': data_dropdown,
  'ks-data-navigation': data_navigation,
  'ks-data-navigation-grid': data_navigation_grid,
  'ks-data-navigation-form': data_navigation_form,
  'ks-list': list,
  'ks-list-header': list_header,
  'ks-list-controller': list_controller,
  'ks-list-table': list_table,
  'ks-list-grid': list_grid,
  'ks-list-map': list_map,
  'ks-list-calendar': list_calendar,
  'ks-list-table-column': list_table_column,
  'ks-list-table-header': list_table_header,
  'ks-row': row,
  'ks-column': column,
  'ks-column-break': column_break,
  'ks-card': card,
  'ks-card-header': card_header,
  'ks-card-body': card_body,
  'ks-campaign-selector-single': campaign_selector_single,
  'ks-menu-view-navigation': menu_view_navigation,
  'ks-tabs': tabs,
  'ks-link-tabs': link_tabs,
  'ks-content-tabs': content_tabs,
  'ks-tab-link': tab_link,
  'ks-tab-content': tab_content,
  'ks-input-address': input_address,
  'ks-input-search': input_search,
  'ks-multi-sort': multi_sort,
  'ks-left-drawer': left_drawer,
  'ks-right-drawer': right_drawer,
  'ks-rich-text-editor': rich_text_editor,
  'ks-scroll-list': infinite_scroll_list,
  'ks-share-modal': share_modal,
  'ks-html-content': html_content,
  'ks-collapse': collapse,
  'ks-collapse-button': collapse_button,
  'ks-merchant-transaction-modal': merchantTransactionModal,
  'ks-print-modal': print_modal,
  'ks-file-viewer': file_viewer,
  'ks-file-viewer-modal': file_viewer_modal,
  'ks-document-wrapper': document_wrapper,
  'ks-toast': toast,
  'ks-map': map,
  'ks-input-file-selector': input_file_selector,
  'ks-calendar': calendar,
  'ks-image-cropper': image_cropper,
  'ks-chart': chart,
  'ks-audio-player': audio_player,
  'ks-video-player': video_player,
  'ks-circle': circle,
  'ks-floating-button': button_floating,
  'ks-page-header': page_header,
  'ks-page-body': page_body,
  'ks-data-mode-selector': data_mode_selector,
  'ks-data-mode-crud-modal': data_mode_crud_modal,
  'ks-custom-select': ks_custom_single_selector,
  'ks-multi-select': ks_multi_selector,
  'ks-multi-select-tree': ks_multi_selector_tree,
  'ks-select-field': ks_single_selector,
  'ks-select-button': ks_single_selector_button,
  'ks-select-radio': ks_single_selector_radio,
  'ks-campaign-multi-selector': ks_campaign_multi_selector,
  'ks-campaign-single-selector': ks_campaign_single_selector,
  'ks-image': image,
  'ks-text': text,
  'ks-flex': flex,
  'ks-icon': icon,
  'ks-popover': popover,
  'ks-alert': alert,
  'ks-skeleton-row': skeleton_row,
  'ks-skeleton-list': skeleton_list,
  'ks-loop': loop,
  'ks-space': space,
  'ks-search': search,
  'ks-group': group,
  'ks-badge': badge,
  'ks-input-search-selector': input_search_selector,
  'ks-confirm': confirm,
  'ks-file-list': file_list,
  'ks-file-selector': file_selector,
  'ks-dropzone': dropzone,
  'ks-input-rich-text': input_rich_text,
  'ks-input-email': input_email,
  'ks-input-phone': input_phone,
  'ks-qr-code': qrcode,

  'ks-data-grid': data_grid,
  'ks-data-grid-header': data_grid_header,
  'ks-data-grid-column': data_grid_column,
  'ks-install-app-button': install_app_button,
  'ks-notification-subscription-button': notification_subscription_button,
  'ks-overlay': overlay,
  'ks-request-performance-logs': requestPerformanceLogs,
};
